window.theme = window.theme || {};
var THMHelper = window.BEYHelper || {};
THMHelper.qs = document.querySelector.bind(document);
THMHelper.qsa = document.querySelectorAll.bind(document);
THMHelper.qid = document.getElementById.bind(document);
THMHelper.qde = document.documentElement;

var Thm = {
  init: function () {
    this.Basic.init();
  },
  Basic: {
    init: function () {
      this.smoothScroll();
      this.marqueeScroller();
      this.slideshowSwiper();
      this.TabSlider();
      this.collapsibleContent();
      this.tab_content()
      this.buyNowButton();
      this.sticky_header();
    },
    tab_content: function () {
      if (!customElements.get('tabbed-content')) {
        class Tabs extends HTMLElement {
          constructor() {
            super();
            this.tabList = this.querySelector('[role="tablist"]');
            this.activeTab = this.tabList.querySelector('[aria-selected="true"]');
            this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';
            this.tabs = this.querySelectorAll('[role="tab"]');
            this.panels = this.querySelectorAll('[role="tabpanel"]');
      
            // If no tab is active by default, activate the first tab.
            if (!this.activeTab) {
              this.activeTab = this.tabs[0];
              this.activateTab(this.activeTab);
            }
      
            this.addListeners();
          }
      
          addListeners() {
            this.tabList.addEventListener('click', this.handleClick.bind(this));
            this.tabList.addEventListener('keydown', this.handleKeydown.bind(this));
          }
      
          handleClick(evt) {
            if (!evt.target.matches('[role="tab"]') || evt.target === this.activeTab) return;
            this.activateTab(evt.target);
      
          }
      
          handleKeydown(evt) {
            switch (evt.key) {
              case 'ArrowLeft':
              case 'ArrowRight':
                evt.preventDefault();
                if (!this.isVerticalTablist) {
                  this.switchTabOnKeyPress(evt.key);
                }
                break;
      
              case 'ArrowUp':
              case 'ArrowDown':
                evt.preventDefault();
                if (this.isVerticalTablist) {
                  this.switchTabOnKeyPress(evt.key);
                }
                break;
      
              case 'Home':
                evt.preventDefault();
                this.activateTab(this.tabs[0]);
                break;
      
              case 'End':
                evt.preventDefault();
                this.activateTab(this.tabs[this.tabs.length - 1]);
                break;
            }
          }
      
          switchTabOnKeyPress(key) {
            if (key === 'ArrowRight' || key === 'ArrowDown') {
              if (this.activeTab === this.tabs[this.tabs.length - 1]) {
                this.activateTab(this.tabs[0]);
              } else {
                this.activateTab(this.activeTab.nextElementSibling);
              }
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
              if (this.activeTab === this.tabs[0]) {
                this.activateTab(this.tabs[this.tabs.length - 1]);
              } else {
                this.activateTab(this.activeTab.previousElementSibling);
              }
            }
          }
      
          activateTab(tab) {
            this.deactivateActiveTab();
      
            Tabs.setTabState(tab, true);
            tab.removeAttribute('tabindex');
            this.activeTab = tab;
      
            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
      
            if (panel) {
              panel.classList.add('fade-in');  // Add animation class
      
              setTimeout(() => {
                panel.classList.remove('fade-in');
              }, 500);
            }
      
            if (document.activeElement.matches('.tablist__tab')) {
              tab.focus();
            }
          }
      
          deactivateActiveTab() {
            Tabs.setTabState(this.activeTab, false);
            this.activeTab.setAttribute('tabindex', '-1');
            this.activeTab = null;
          }
      
          static setTabState(tab, active) {
            tab.setAttribute('aria-selected', active);
      
            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
      
            if (panel) {
              if (active) {
                panel.hidden = false;
              } else {
                panel.hidden = true;
              }
            }
          }
      
        }
      
        customElements.define('tabbed-content', Tabs);
      }
    },
    sticky_header: function () {
      var header = document.querySelector('[data-sticky-type="always"]');

      if(header != null){
      onScroll = () => {
        var scrolledPage = Math.round(window.pageYOffset);
        if (scrolledPage > 80) {
          header.classList.add('sticky');
        } else {
          header.classList.remove('sticky');
        }
      }
      document.addEventListener('scroll', onScroll);
         }
    },
    smoothScroll: function () {
      document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])').forEach(a => {
        a.addEventListener('click', function (e) {
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = document.querySelector(this.hash) || document.querySelector('[name=' + this.hash.slice(1) + ']');
            if (target) {
              e.preventDefault();
              window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
              setTimeout(() => {
                target.focus();
                if (!target.matches(':focus')) {
                  target.setAttribute('tabindex', '-1');
                  target.focus();
                }
              }, 600);
            }
          }
        });
      });

    },
    marqueeScroller: function () {
      if (!customElements.get("marquee-content")) {
        class Marquee extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          calculationPaddingSection() {
            (this.heightSection = this.offsetHeight),
              (this.heightSection =
                this.heightSection < 18
                  ? 18
                  : 96 < this.heightSection
                    ? 96
                    : this.heightSection),
              this.closest(".js-running-content").style.setProperty(
                "--spacing-padding-block",
                this.heightSection + "px"
              );
          }
          init() {
            (this.distance =
              this.querySelector(".js-marquee-item").offsetWidth),
              (this.speed = this.dataset.speed),
              this.style.setProperty(
                "--marquee-duration",
                this.distance / this.speed + "s"
              );
          }
        }
        customElements.define("marquee-content", Marquee);
      }
    },
    slideshowSwiper: function () {

      class slideshowSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.sliderWrapper = this.querySelector(".slideshow__swiper");

          let centered_slides =
            this.sliderWrapper.dataset.centeredslides !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
              : undefined;
          let effect_fade =
            this.sliderWrapper.dataset.effectfade !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.effectfade)
              : undefined;
          let next = this.querySelector(".swiper-button-next");
          let prev = this.querySelector(".swiper-button-prev");
          let pagination = this.querySelector(".swiper-pagination");
          let scroll = this.querySelector(".swiper-scrollbar");

          new Swiper(this.sliderWrapper, {
            effect: effect_fade ? "fade" : "slide",
            centeredSlides: centered_slides ? centered_slides : false,
            slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
            spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
            grabCursor: false,
            horizontal: true,
            watchSlidesProgress: true,
            draggable: !0,
            autoHeight: !1,
            watchOverflow: !0,
            threshold: 10,
            freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
            loop: JSON.parse(this.sliderWrapper.dataset.loop),
            speed: 700,
            mousewheel: {
              forceToAxis: true,
            },
            autoplay: {
              enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
              disableOnInteraction: false,
              delay: parseInt(this.sliderWrapper.dataset.delay),
            },
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
            pagination: {
              el: pagination,
              clickable: true,
            },
            scrollbar: {
              el: scroll,
              draggable: true,
            },
            breakpoints: {
              359: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
                spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
              },
              768: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
                spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
              },
              1024: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
                spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
              },
            },
          });
        }
      }
      customElements.define("slideshow-swiper", slideshowSwiper);

    },
    TabSlider: function () {
 
      
      class TabSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          let next = this.querySelector(".swiper-button-next");
          let prev = this.querySelector(".swiper-button-prev");
      var sliderTab = new Swiper('.slider-tab', {
        centeredSlides: false,
        centeredSlidesBounds: true, 
        direction: "horizontal",
        spaceBetween: 55,
        slidesPerView: 4,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        allowTouchMove: true,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          359: {
            slidesPerView: 2,
            centeredSlides: false,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: "auto",
            spaceBetween: 55,
          }
        },
      });
      
      
      var sliderTabContent = new Swiper(".slider-tab-content", {
        loop: true,
        slidesPerView: 1,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: 0,
        allowTouchMove: true,
        thumbs: {
          swiper: sliderTab
        }
      });
      
      
      sliderTab.on("slideChangeTransitionStart", function () {
        sliderTabContent.slideTo(sliderTab.activeIndex);
      });
      sliderTabContent.on("transitionStart", function () {
        sliderTab.slideTo(sliderTabContent.activeIndex);
      });
    }

  }

      customElements.define("tab-swiper", TabSwiper);
      
      // sliderThumbnail.controller.control = sliderContent;
      // sliderContent.controller.control = sliderThumbnail;
    },
    collapsibleContent: function () {
      if (!customElements.get("collapsible-content")) {
        class collapsibleContent extends HTMLElement {
          constructor() {
            super();
            this.disclosure = this.querySelector('details');
            this.toggle = this.querySelector('summary');
            this.panel = this.toggle.nextElementSibling;
            this.init();
          }

          init() {
            // Check if the content element has a CSS transition.
            if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
              this.toggle.addEventListener('click', this.handleToggle.bind(this));
              this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
            }
          }

          /**
           * Handles 'click' events on the summary element.
           * @param {object} evt - Event object.
           */
          handleToggle(evt) {
            evt.preventDefault();

            if (!this.disclosure.open) {
              this.open();
            } else {
              this.close();
            }
          }

          /**
           * Handles 'transitionend' events on the details element.
           * @param {object} evt - Event object.
           */
          handleTransitionEnd(evt) {
            if (evt.target !== this.panel) return;

            if (this.disclosure.classList.contains('is-closing')) {
              this.disclosure.classList.remove('is-closing');
              this.disclosure.open = false;
            }

            this.panel.removeAttribute('style');
          }

          /**
           * Adds inline 'height' style to the content element, to trigger open transition.
           */
          addContentHeight() {
            this.panel.style.height = `${this.panel.scrollHeight}px`;
          }

          /**
           * Opens the details element.
           */
          open() {
            // Set content 'height' to zero before opening the details element.
            this.panel.style.height = '0';

            // Open the details element
            this.disclosure.open = true;

            // Set content 'height' to its scroll height, to enable CSS transition.
            this.addContentHeight();
          }

          /**
           * Closes the details element.
           */
          close() {
            // Set content height to its scroll height, to enable transition to zero.
            this.addContentHeight();

            // Add class to enable styling of content or toggle icon before or during close transition.
            this.disclosure.classList.add('is-closing');

            // Set content height to zero to trigger the transition.
            // Slight delay required to allow scroll height to be applied before changing to '0'.
            setTimeout(() => {
              this.panel.style.height = '0';
            });
          }
        }
        customElements.define('collapsible-content', collapsibleContent);
      }
    },
    buyNowButton: function () {
      class ShopifyBuyNowHandler {
        constructor() {
          this.initials();
        }

        initials() {
          document.querySelectorAll('.buy-now-js').forEach((button) => {
            button.addEventListener('click', (e) => this.handleClick(e, button));
          });
        }

        handleClick(e, button) {
          e.preventDefault();

          const form = button.closest('form');
          if (!form) return;

          button.classList.add('loading');
          const spinner = button.querySelector('.loading__spinner_cricle');
          if (spinner) spinner.classList.remove('hidden');

          const formData = new FormData(form);
          const url = '/cart/add.js';

          fetch(url, {
            method: 'POST',
            body: formData, // Shopify expects FormData, not JSON
          })
            .then((response) => {
              if (!response.ok) throw new Error('Failed to add item');
              return response.json();
            })
            .then(() => {
              button.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
              window.location.href = '/checkout'; // Direct call instead of this.redirectToCheckout()
            })
            .catch((error) => {
              console.error('Error adding to cart:', error);
              button.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
            });
        }
      }
      // Initialize Immediately
      new ShopifyBuyNowHandler();

      
    }
  },
};


document.addEventListener('DOMContentLoaded', function () {
  Thm.init();
});



class THMLazyLoadingVideo extends HTMLElement {
    constructor() {
      super(),
        (this.iframe = this.querySelector("iframe")),
        (this.template = this.querySelector("template")),
        (this.isMouseenter = !1);
    }
 
    loadVideo() {
  if (this.dataVideoType === "local_video") {
    const videoElement = this.querySelector("video");
    const sourceElement = videoElement?.querySelector("source");
    const videoSrc = sourceElement?.getAttribute("data-src");

    if (videoSrc) {
      sourceElement.setAttribute("src", videoSrc);
      videoElement.load();
      videoElement.muted = true;

      videoElement.addEventListener("canplay", () => {
        videoElement.play().catch(err => {
          console.warn("Autoplay failed:", err);
        });
      });
    } else {
      console.warn("Missing data-src on local video source.");
    }
  }

  // ✅ Add this block for YouTube & Vimeo
  else if (this.dataVideoType === "youtube" || this.dataVideoType === "vimeo") {
    const iframe = this.querySelector("iframe");
    const iframeSrc = iframe?.getAttribute("data-src");

    if (iframe && iframeSrc) {
      iframe.setAttribute("src", iframeSrc);
    } else {
      console.warn("Missing data-src on iframe.");
    }
  }
}


    
    execute() {
      Shopify.designMode
        ? this.loadVideo()
        : (["mousemove", "touchstart"].forEach(
            function (t) {
              THMHelper.qs("body").addEventListener(
                t,
                function (t) {
                  this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                }.bind(this),
                { once: !0 }
              );
            }.bind(this)
          ),
          window.addEventListener(
            "scroll",
            function (t) {
              this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
            }.bind(this),
            { once: !0 }
          ));
    }
    static get observedAttributes() {
      return ["data-video-type", "data-video-id"];
    }
    set dataVideoType(t) {
      this.setAttribute("data-video-type", t);
    }
    get dataVideoType() {
      return this.getAttribute("data-video-type");
    }
    set dataVideoId(t) {
      this.setAttribute("data-video-id", t);
    }
    get dataVideoId() {
      return this.getAttribute("data-video-id");
    }
    attributeChangedCallback(t, e, s) {
      e !== s && this.execute();
    }
    connectedCallback() {
      this.execute();
    }
    disconnectedCallback() {}
  }
  customElements.define("thm-load-video", THMLazyLoadingVideo);

  class THMLoadMedia extends HTMLElement {
    constructor() {
      super(),
        (this.$ = this.querySelector.bind(this)),
        (this.sectionID = this.dataset.sectionId),
        (this.idVideo = this.dataset.idVideo),
        (this.typeVideo = this.dataset.type),
        (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
        (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
        (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
        (this.trigger = this.$(".js-load-media-trigger")),
        this.trigger &&
          this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));
    }
    handlePlayVideo() {
      this.classList.add("playing");
      this.loadContent();
      const t = this.querySelector(".js-media-item-video");
      t &&
        t.addEventListener("play", () => {
          this.pauseAllVideo(t), t.play();
        });
    }
    onYouTubeIframeAPIReady() {
      if ("undefined" != typeof YT && void 0 !== YT.Player)
        try {
          this.player = new YT.Player(this.eleVideo, {
            videoId: this.idVideo,
            playerVars: { playsinline: 1 },
            events: {
              onReady: this.onPlayerYTReady,
              onStateChange: this.onPlayerStateYTChange,
            },
          });
        } catch (t) {
          console.error("Lỗi khi tạo trình phát YouTube:", t);
        }
      else {
        var t = document.createElement("script"),
          e =
            ((t.src = "https://www.youtube.com/iframe_api"),
            (t.onload = () => {
              this.onYouTubeIframeAPIReady();
            }),
            document.getElementsByTagName("script")[0]);
        e.parentNode.insertBefore(t, e);
      }
    }
    onVimeoIframeAPIReady() {
      if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
        try {
          var t = { id: this.idVideo, autoplay: 1 };
          (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
            this.playerVimeo.on("play", () => {
              this.pauseAllVideo(this.playerVimeo);
            });
        } catch (t) {
          console.error("Lỗi khi tạo trình phát Vimeo:", t);
        }
      else {
        var t = document.createElement("script"),
          e =
            ((t.src = "https://player.vimeo.com/api/player.js"),
            (t.onload = () => {
              this.onVimeoIframeAPIReady();
            }),
            document.getElementsByTagName("script")[0]);
        e.parentNode.insertBefore(t, e);
      }
    }
    onPlayerYTReady = () => {
      this.pauseAllVideo(this.player), this.player.playVideo();
    };
    onPlayerStateYTChange = (t) => {
      1 == t.data && this.onPlayerPlay();
    };
    onPlayerPlay = () => {
      this.pauseAllVideo(this.player);
    };
    loadContent() {
      if (!this.getAttribute("loaded")) {
        if (this.$("template")) {
          var t = this.$("template").content.firstElementChild.cloneNode(!0);
          this.appendChild(t),
            this.isLoaded(!0),
            this.trigger && this.trigger.remove();
        } else {
          if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
          else {
            if ("vimeo" != this.typeVideo) return !0;
            this.onVimeoIframeAPIReady();
          }
          this.trigger?.classList.add("d-none"),
            this.$(".js-media-item").classList.add("d-flex");
        }
        return !0;
      }
    }
    pauseAllVideo(e) {
      THMHelper.qsa(
        ".js-product-media-deferred-video:has([data-type='youtube']"
      ).forEach((t) => {
        t.player && e !== t.player && t.player?.pauseVideo();
      }),
      THMHelper.qsa(
          ".js-product-media-deferred-video:has([data-type='vimeo'])"
        ).forEach((t) => {
          t.playerVimeo !== e && t.playerVimeo?.pause();
        }),
        THMHelper.qsa(".js-media-item-video").forEach((t) => {
          t !== e && t.pause();
        });
    }
    isLoaded(t) {
      t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
    }
  }
  customElements.define("thm-load-media", THMLoadMedia);


['touchstart', 'click'].forEach(event => {
  window.addEventListener(event, () => {
    userInteracted = true;

    // Preload all videos in thm-load-video components
    document.querySelectorAll('thm-load-video').forEach(el => {
      el.loadVideo?.();
    });

  }, { once: true });
});








      // class productSwiper extends HTMLElement {
      //   constructor() {
      //     super();
      //   }
      //   connectedCallback() {
      //     this.sliderWrapper = this.querySelector(".slideshow__swiper");

      //     let centered_slides =
      //       this.sliderWrapper.dataset.centeredslides !== undefined
      //         ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
      //         : undefined;
      //     let effect_fade =
      //       this.sliderWrapper.dataset.effectfade !== undefined
      //         ? JSON.parse(this.sliderWrapper.dataset.effectfade)
      //         : undefined;
      //     let next = this.querySelector(".swiper-button-next");
      //     let prev = this.querySelector(".swiper-button-prev");
      //     let pagination = this.querySelector(".swiper-pagination");
      //     let scroll = this.querySelector(".swiper-scrollbar");

      //     new Swiper(this.sliderWrapper, {
      //       effect: effect_fade ? "fade" : "slide",
      //       centeredSlides: centered_slides ? centered_slides : false,
      //       slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
      //       spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
      //       grabCursor: false,
      //       horizontal: true,
      //       watchSlidesProgress: true,
      //       draggable: !0,
      //       autoHeight: !1,
      //       watchOverflow: !0,
      //       threshold: 10,
      //       freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
      //       loop: JSON.parse(this.sliderWrapper.dataset.loop),
      //       speed: 700,
      //       mousewheel: {
      //         forceToAxis: true,
      //       },
      //       autoplay: {
      //         enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
      //         disableOnInteraction: false,
      //         delay: parseInt(this.sliderWrapper.dataset.delay),
      //       },
      //       navigation: {
      //         nextEl: next,
      //         prevEl: prev,
      //       },
      //       pagination: {
      //         el: pagination,
      //         clickable: true,
      //       renderBullet: function (index, className) {
      //           const paddedNumber = String(index + 1).padStart(2, '0');
      //           return '<span class="' + className + '">' + paddedNumber + '</span>';
      //         }
      //       },
      //       scrollbar: {
      //         el: scroll,
      //         draggable: true,
      //       },
      //       breakpoints: {
      //         359: {
      //           slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
      //           spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
      //         },
      //         768: {
      //           slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
      //           spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
      //         },
      //         1024: {
      //           slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
      //           spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
      //         },
      //       },
      //     });
      //   }
      // }
      // customElements.define("product-swiper", productSwiper);



class THMLoadMediaButton extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.sectionID = this.dataset.sectionId;
    this.idVideo = this.dataset.idVideo;
    this.typeVideo = this.dataset.type;
    this.eleVideo = `shtVideo-${this.sectionID}-${this.idVideo}`;

    
    this.trigger = this.$(".js-load-media-trigger");
     this.playBtn = this.$(".video-play-toggler");


    this.volumeBtn = null;
  }

  connectedCallback() {
    this.trigger?.addEventListener("click", () => this.handlePlayVideo());
      this.playBtn?.addEventListener("click", this.handlePlayVideo.bind(this)); // ✅ now works same as trigger

  }

  handlePlayVideo() {
    this.classList.add("playing");

    if (!this.getAttribute("loaded")) {
      this.loadContent(() => {
        this.playVideo(); // Play after loading
      });
    } else {
      this.playVideo();
    }
  }

  togglePlayPause() {
    const vid = this.$(".js-media-item-video");
    if (!vid) {
      // If not loaded, load first and play
      this.loadContent(() => {
        this.playVideo();
      });
      return;
    }

    if (vid.paused) {
      this.pauseAllVideo(vid);
      vid.play();
      this.updatePlayUI(true);
      this.trigger?.classList.add("d-none");
    } else {
      vid.pause();
      this.updatePlayUI(false);
      this.trigger?.classList.remove("d-none");
    }
  }

  toggleVolume() {
    const vid = this.$(".js-media-item-video");
    if (!vid) return;

    vid.muted = !vid.muted;
    this.updateVolumeUI(vid.muted);
  }

  playVideo() {
    const vid = this.$(".js-media-item-video");
    if (!vid) return;

    this.pauseAllVideo(vid);
    vid.play();
    this.updatePlayUI(true);
    this.updateVolumeUI(vid.muted);
    this.trigger?.classList.add("d-none");

    vid.addEventListener("pause", () => {
      this.updatePlayUI(false);
      this.trigger?.classList.remove("d-none");
    });

    vid.addEventListener("volumechange", () => {
      this.updateVolumeUI(vid.muted);
    });
  }

  updatePlayUI(isPlaying) {
    if (this.playBtn) {
      this.playBtn.classList.toggle("active", isPlaying);
    }
  }

  updateVolumeUI(isMuted) {
    if (this.volumeBtn) {
      this.volumeBtn.classList.toggle("active", isMuted);
    }
  }

  loadContent(callback) {
    if (this.getAttribute("loaded")) {
      callback?.();
      return;
    }

    const template = this.$("template");
    if (template) {
      const tpl = template.content.firstElementChild.cloneNode(true);
      this.appendChild(tpl);
      this.isLoaded(true);
      this.trigger?.classList.add("d-none");

      // Delay to allow DOM to update
      setTimeout(() => {
        this.playBtn = this.$(".video-play-toggler");
        this.volumeBtn = this.$(".video-volume-icon");

        this.playBtn?.addEventListener("click", () => this.togglePlayPause());
        this.volumeBtn?.addEventListener("click", () => this.toggleVolume());

        callback?.();
      }, 50);
    }
  }

  pauseAllVideo(currentPlayer) {
    document.querySelectorAll("thmload-mediabutton").forEach((el) => {
      if (el === this) return;
      const vid = el.querySelector(".js-media-item-video");
      if (vid && vid !== currentPlayer) vid.pause?.();
    });
  }

  isLoaded(value) {
    value
      ? this.setAttribute("loaded", "true")
      : this.removeAttribute("loaded");
  }
}

customElements.define("thmload-mediabutton", THMLoadMediaButton);



// product-swiper

// class productSwiper extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const sliderWrapper = this.querySelector(".slideshow__swiper");
//     const thumbnailWrapper = this.querySelector(".thumbnail-swiper");

//     const next = this.querySelector(".swiper-button-next");
//     const prev = this.querySelector(".swiper-button-prev");
//     const pagination = this.querySelector(".swiper-pagination");
//     const scroll = this.querySelector(".swiper-scrollbar");

//     const centered_slides = sliderWrapper.dataset.centeredslides === "true";
//     const effect_fade = sliderWrapper.dataset.effectfade === "true";



//     // Init thumbnail slider first
//     const thumbnailSlider = new Swiper(thumbnailWrapper, {
//       slidesPerView: 4,
//       spaceBetween: 10,
//       watchSlidesProgress: true,
//       watchSlidesVisibility: true,
//       slideToClickedSlide: true,
//       freeMode: true,
//       breakpoints: {
//         768: { slidesPerView: 4, spaceBetween: 10 },
//         1024: { slidesPerView: 4, spaceBetween: 10 },
//       },
//     });

//     // Then init main slider
//     const mainSlider = new Swiper(sliderWrapper, {
//       effect: effect_fade ? "fade" : "slide",
//       centeredSlides: centered_slides,
//       slidesPerView: parseInt(sliderWrapper.dataset.slidesmobile),
//       spaceBetween: parseInt(sliderWrapper.dataset.mobilespace),
//       grabCursor: false,
//       watchSlidesProgress: true,
//       draggable: true,
//       autoHeight: false,
//       watchOverflow: true,
//       threshold: 10,
//       freeMode: JSON.parse(sliderWrapper.dataset.freemode),
//       loop: JSON.parse(sliderWrapper.dataset.loop),
//       speed: 700,
//       mousewheel: { forceToAxis: true },
//       autoplay: {
//         enabled: JSON.parse(sliderWrapper.dataset.autoplay),
//         disableOnInteraction: false,
//         delay: parseInt(sliderWrapper.dataset.delay),
//       },
//       navigation: { nextEl: next, prevEl: prev },
//       pagination: {
//         el: pagination,
//         clickable: true,
//         renderBullet: function (index, className) {
//           const paddedNumber = String(index + 1).padStart(2, "0");
//           return `<span class="${className}">${paddedNumber}</span>`;
//         },
//       },
//       scrollbar: { el: scroll, draggable: true },
//       breakpoints: {
//         359: {
//           slidesPerView: parseFloat(sliderWrapper.dataset.slidesmobile),
//           spaceBetween: parseInt(sliderWrapper.dataset.mobilespace),
//         },
//         768: {
//           slidesPerView: parseFloat(sliderWrapper.dataset.slidestab),
//           spaceBetween: parseInt(sliderWrapper.dataset.tabspace),
//         },
//         1024: {
//           slidesPerView: parseFloat(sliderWrapper.dataset.slidesdesktop),
//           spaceBetween: parseInt(sliderWrapper.dataset.desktopspace),
//         },
//       },
//       thumbs: {
//         swiper: thumbnailSlider
//       }
//     });
//   }
// }

// customElements.define("product-swiper", productSwiper);



class productSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sliderWrapper = this.querySelector(".slideshow__swiper");
    const thumbnailWrapper = this.querySelector(".thumbnail-swiper");

    const next = this.querySelector(".swiper-button-next");
    const prev = this.querySelector(".swiper-button-prev");
    const pagination = this.querySelector(".swiper-pagination");
    const scroll = this.querySelector(".swiper-scrollbar");

    const centered_slides = sliderWrapper.dataset.centeredslides === "true";
    const effect_fade = sliderWrapper.dataset.effectfade === "true";

    let thumbnailSlider = null;
    let thumbsConfig = {};

    // ✅ Init thumbnail slider only if it exists
    if (thumbnailWrapper) {
      thumbnailSlider = new Swiper(thumbnailWrapper, {
        slidesPerView: 5,
        spaceBetween: 10,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slideToClickedSlide: true,
        freeMode: true,
        breakpoints: {
          768: { slidesPerView: 5, spaceBetween: 10 },
          1024: { slidesPerView: 6, spaceBetween: 10 },
        },
      });

      thumbsConfig = {
        thumbs: {
          swiper: thumbnailSlider
        }
      };
    }

    // ✅ Init main slider, with or without thumbs
    const mainSlider = new Swiper(sliderWrapper, {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides,
      slidesPerView: parseInt(sliderWrapper.dataset.slidesmobile),
      spaceBetween: parseInt(sliderWrapper.dataset.mobilespace),
      grabCursor: false,
      watchSlidesProgress: true,
      draggable: true,
      autoHeight: false,
      watchOverflow: true,
      threshold: 10,
      freeMode: JSON.parse(sliderWrapper.dataset.freemode),
      loop: JSON.parse(sliderWrapper.dataset.loop),
      speed: 700,
      mousewheel: { forceToAxis: true },
      autoplay: {
        enabled: JSON.parse(sliderWrapper.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(sliderWrapper.dataset.delay),
      },
      navigation: { nextEl: next, prevEl: prev },
      pagination: {
        el: pagination,
        clickable: true,
        renderBullet: function (index, className) {
          const paddedNumber = String(index + 1).padStart(2, "0");
          return `<span class="${className}">${paddedNumber}</span>`;
        },
      },
      scrollbar: { el: scroll, draggable: true },
      breakpoints: {
        359: {
          slidesPerView: parseFloat(sliderWrapper.dataset.slidesmobile),
          spaceBetween: parseInt(sliderWrapper.dataset.mobilespace),
        },
        768: {
          slidesPerView: parseFloat(sliderWrapper.dataset.slidestab),
          spaceBetween: parseInt(sliderWrapper.dataset.tabspace),
        },
        1024: {
          slidesPerView: parseFloat(sliderWrapper.dataset.slidesdesktop),
          spaceBetween: parseInt(sliderWrapper.dataset.desktopspace),
        },
      },
      ...thumbsConfig // ✅ only included if thumbnail exists
    });
  }
}

customElements.define("product-swiper", productSwiper);



document.addEventListener('DOMContentLoaded', function () {
  const hiddenInput = document.querySelector('input[name="selling_plan"]');
  const basePrice = document.querySelector('.one-time__item')?.dataset.price;

  function updatePrice(amount, type = 'both') {
    const plainPrice = amount;

    const regularPriceEl = document.querySelector('.price__regular .price-item--regular .money');
    if (regularPriceEl) regularPriceEl.innerHTML = plainPrice;

    const salePriceEl = document.querySelector('.price__sale .price-item--sale .money');
    if (salePriceEl) salePriceEl.innerHTML = plainPrice;

    if (type === 'subscription' || type === 'both') {
      const activePlan = document.querySelector('.selling-plan__item_plan.active');
      if (activePlan) {
        const priceEl = activePlan.querySelector('.selling__price');
        if (priceEl) priceEl.textContent = plainPrice;
      }
    }

    if (type === 'onetime' || type === 'both') {
      const oneTimePriceEl = document.querySelector('.onetime__price');
      if (oneTimePriceEl) oneTimePriceEl.textContent = plainPrice;
    }
  }

  function updateSaveBadge(discountPercent, show = true) {
    const badge = document.querySelector('.save-badge');
    const percentEl = badge?.querySelector('.save-percent');

    // const parent = document.querySelector('.selling-plans');
    // const firstChild = parent.firstElementChild;

    console.log(badge, percentEl, discountPercent)

    if (badge && percentEl) {
      if (show && discountPercent > 0) {
        percentEl.textContent = `${discountPercent}%`;
        badge.style.display = 'inline-flex';
      } else {
        badge.style.display = 'none';
      }
    }
  }

  // Event delegation for plan items
  document.addEventListener('click', function (e) {
    const item = e.target.closest('.selling-plan__item_plan');
    if (!item) return;

    document.querySelectorAll('.selling-plan__item_plan').forEach(i => i.classList.remove('active'));
    item.classList.add('active');

    const sellingType = item.dataset.sellingType;
    const select = document.querySelector('.form-select');

    console.log(sellingType)

    if (sellingType === 'autodeliver') {
      select?.dispatchEvent(new Event('change'));
      const planId = item.dataset.sellingId;

      hiddenInput.value = planId || '';
      document.querySelector('input[name="selling_plan"]').value = planId;

    } else if (sellingType === 'one_time') {
      hiddenInput.value = '';
      document.querySelector('input[name="selling_plan"]').value = '';
      updatePrice(basePrice, 'onetime');
      // updateSaveBadge(0, false);
    }
  });

  // Event delegation for select change
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.form-select')) return;

    const planItems = document.querySelectorAll('.selling-plan__item_plan');
    const subscriptionActive = Array.from(planItems).some(
      i => i.classList.contains('active') && i.dataset.sellingType === 'autodeliver'
    );
    if (!subscriptionActive) return;

    const selectedOption = e.target.options[e.target.selectedIndex];
    const planId = selectedOption.dataset.sellingId;
    const discountedPrice = selectedOption.dataset.discountedPrice;
    const discountPercent = selectedOption.dataset.discountPercentage;


    hiddenInput.value = planId || '';
    document.querySelector('input[name="selling_plan"]').value = planId;
    updatePrice(discountedPrice, 'subscription');
    updateSaveBadge(discountPercent, true);
  });

  // Set initial state
  const oneTimePlan = document.querySelector('.one-time__item');
  if (oneTimePlan) oneTimePlan.classList.add('active');

  updatePrice(basePrice, 'onetime');
});





 document.addEventListener('DOMContentLoaded', function () {
  const radioButtons = document.querySelectorAll('.quantity-box input[type="radio"][name="quantity"]');

  radioButtons.forEach((radio) => {
    radio.addEventListener('change', function () {
      if (this.checked) {
        const container = this.closest('.quantity-box');
        const quantityInput = container.querySelector('.quantity__input_custom');
        
        if (quantityInput) {
          quantityInput.value = this.value;
        }
      }
    });
  });
});



document.addEventListener('click', function (e) {
  var backBtn = e.target.closest('.jdgm-write-review-modal__nav-btn-back');
  if (backBtn) {
    var closeBtn = document.querySelector('.jdgm-write-review-modal__close-btn');

    if (closeBtn) {
      closeBtn.removeAttribute('style');
    }
  }
});

